import { availableFacetFields, normalizeFacetSelections, type FacetSelections } from "./data/facets";
import type { CategoryId } from "./types";
import "./category-facets.css";

export type CategoryFacetsProps = {
  category: CategoryId | "all";
  values: FacetSelections;
  onChange: (values: FacetSelections) => void;
  mode: "filter" | "listing";
};

export default function CategoryFacets({ category, values, onChange, mode }: CategoryFacetsProps) {
  const selected = normalizeFacetSelections(category, values);
  const fields = availableFacetFields(category).filter((field) => !(mode === "listing" && category === "telescopes" && selected.telescope_setup?.[0] === "tube_only" && field.key === "mount_type"));

  function changeField(key: string, next: string[]) {
    const changed = { ...selected, [key]: next };
    if (mode === "filter" && category === "telescopes" && key === "mount_type" && next.length && changed.telescope_setup?.[0] === "tube_only") delete changed.telescope_setup;
    onChange(normalizeFacetSelections(category, changed));
  }

  return <fieldset className={`category-facets category-facets-${mode}`}>
    <legend>Caratteristiche</legend>
    {category === "all" ? <p className="category-facets-hint">Scegli una categoria per vedere le caratteristiche specifiche.</p> : <>
      {mode === "listing" && <p className="category-facets-hint">Dettagli facoltativi: seleziona solo le caratteristiche che conosci. L’attacco dichiarato non garantisce la compatibilità.</p>}
      <div className="category-facet-fields">{fields.map((field) => mode === "listing" && field.multi ?
        <fieldset key={field.key} className="category-facet-options"><legend>{field.label} <span>(facoltative)</span></legend>
          {field.options.map((option) => <label key={option.value} className="check-field"><input type="checkbox" name={`facets[${field.key}][]`} value={option.value} checked={selected[field.key]?.includes(option.value) || false} onChange={(event) => changeField(field.key, event.target.checked ? [...(selected[field.key] || []), option.value] : (selected[field.key] || []).filter((value) => value !== option.value))} /><span>{option.label}</span></label>)}
        </fieldset> :
        <label key={field.key} className={`field${mode === "filter" ? " compact" : ""}`}><span>{field.label}{mode === "listing" ? " (facoltativo)" : ""}</span><select name={mode === "listing" && selected[field.key]?.length ? `facets[${field.key}][]` : undefined} value={selected[field.key]?.[0] || ""} onChange={(event) => changeField(field.key, event.target.value ? [event.target.value] : [])}>
          <option value="">{mode === "filter" ? "Qualsiasi" : "Non specificato"}</option>
          {field.options.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
        </select></label>
      )}</div>
    </>}
  </fieldset>;
}
